// extracted by mini-css-extract-plugin
export var key = "KeyValue-module--key--53f4d";
export var value = "KeyValue-module--value--fe207";
export var wrapper = "KeyValue-module--wrapper--76aae";